import { app } from '../app';

class CompanyUserResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    logCompanyAccessed(companyId) {
        const url = `app/rest/companies/${companyId}/companyusers/access`;
        return this.$http.get(url).then(({data}) => data);
    }
}

app.service('CompanyUserResource', CompanyUserResource);



// WEBPACK FOOTER //
// ./src/portal/services/company-user-resource.service.js